/* ============================================================
   INDSO — search.js
   Live predictive search dropdown. Queries Shopify's
   /search/suggest endpoint and renders the predictive-search
   section. The form still submits to the full results page,
   matching the original "search as you type" + Enter behavior.
   ============================================================ */
(function () {
  'use strict';

  const ready = (fn) =>
    document.readyState !== 'loading'
      ? fn()
      : document.addEventListener('DOMContentLoaded', fn);

  function initPredictive() {
    const wrapper = document.querySelector('[data-predictive-search]');
    if (!wrapper) return;
    const input = wrapper.querySelector('[data-search-input]');
    const resultsEl = wrapper.querySelector('[data-predictive-results]');
    if (!input || !resultsEl) return;

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    let debounce;
    let controller;

    const showResults = () => {
      resultsEl.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    };
    const hideResults = () => {
      resultsEl.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    };

    async function fetchResults(term) {
      if (controller) controller.abort();
      controller = new AbortController();

      const params = new URLSearchParams({
        q: term,
        'resources[type]': 'product,query',
        'resources[limit]': '6',
        section_id: 'predictive-search',
      });

      try {
        const res = await fetch(`${root}search/suggest?${params}`, { signal: controller.signal });
        const text = await res.text();
        resultsEl.innerHTML = text;
        const hasContent = resultsEl.querySelector('.predictive__group, .predictive__empty');
        if (hasContent) {
          showResults();
        } else {
          resultsEl.innerHTML = '';
          hideResults();
        }
      } catch (e) {
        if (e.name !== 'AbortError') hideResults();
      }
    }

    input.addEventListener('input', () => {
      const term = input.value.trim();
      clearTimeout(debounce);
      if (term.length < 2) { hideResults(); return; }
      debounce = setTimeout(() => fetchResults(term), 200);
    });

    input.addEventListener('focus', () => {
      if (resultsEl.innerHTML.trim() && input.value.trim().length >= 2) showResults();
    });

    // Close on outside click / Escape
    document.addEventListener('click', (e) => {
      if (!wrapper.contains(e.target)) hideResults();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { hideResults(); input.blur(); }
    });
  }

  ready(initPredictive);
})();
